module.exports = __webpack_public_path__ + "static/media/jurassic-giants.8633c917.gif";